import { DECREMENT_LOADER_COUNT, INCREMENT_LOADER_COUNT } from "../types";

export const incrementLoaderCount = () => ({
	type: INCREMENT_LOADER_COUNT,
});

export const decrementLoaderCount = () => ({
	type: DECREMENT_LOADER_COUNT,
});
